



































































































































































































































































































































































































































import { Component, Mixins, Watch } from "vue-property-decorator";
import OrderSummary from "@/components/checkout/OrderSummary.vue";
import { namespace } from "vuex-class";
import { StoreModule } from "@/store/types";
import { OrderGetters, OrderActions } from "@/store/modules/order/types";
import {
  LineItem,
  LineItemRecord,
  Note,
  Order,
  OrderDetails,
  OrderRecord,
} from "@/models/order/order";
import LineItemRow from "@/components/cart/LineItemRow.vue";
import QtyPickerCart from "@/components/elements/utility/QtyPickerCart.vue";
import ConfirmDelete from "@/components/elements/modal/ConfirmDelete.vue";
import OrderService from "@/services/order_service";
import { GenericError } from "@/services/error_service";
import { ProductType } from "@/models/products/product";
import CartFooter from "@/components/footer/CartFooter.vue";
import { Mobile } from "@/mixins/mobile";
import { CreatedType, OrderStatus } from "@/models/order/helpers";
import { GlobalActions, GlobalGetters } from "@/store/modules/global/types";
import CustomerService from "@/services/customer_service";
import { FinishDisplayName, FinishHandle } from "@/models/products/finish";
import { getFinishName } from "@/utility/helpers";
import FabricService from "@/services/fabric_service";
import * as option from "../../models/configurator/configurator_options";
import { OrderMixin } from "@/mixins/orders/mixin";

@Component({
  components: {
    OrderSummary,
    LineItemRow,
    QtyPickerCart,
    ConfirmDelete,
    CartFooter,
  },
})
export default class Cart extends Mixins(Mobile, OrderMixin) {
  @(namespace(StoreModule.Order).Action(OrderActions.AddLineItem))
  addItem!: (value: LineItem) => Promise<void>;
  @(namespace(StoreModule.Order).Action(OrderActions.ReplaceLineItems))
  replaceLineItems!: (value: LineItem[] | LineItemRecord[]) => Promise<void>;
  @(namespace(StoreModule.Order).Action(OrderActions.AddOrder))
  addOrder!: (value: Order) => Promise<void>;
  @(namespace(StoreModule.Global).Action(GlobalActions.AddMultiplier))
  addMultiplier!: (value: number) => Promise<void>;
  @(namespace(StoreModule.Global).Getter(GlobalGetters.GetMultiplier))
  multiplier!: number;
  @(namespace(StoreModule.Order).Action(OrderActions.ClearOrder))
  resetOrder!: () => Promise<void>;
  @(namespace(StoreModule.Order).Action(OrderActions.AddCostDetails))
  addCostDetails!: (value: OrderDetails["cost_details"]) => Promise<void>;
  @(namespace(StoreModule.Order).Action(OrderActions.AssignCustomer))
  assignCustomer!: (value: {
    customer_id: string;
    customer_name: string;
    order_id: string | null;
  }) => Promise<void>;
  protected showModal = false;
  protected orderService = new OrderService();
  protected customerService = new CustomerService();
  protected fabricService = new FabricService();
  protected upForDelete: number | null = null;
  protected loader: any = null;
  protected id = "";
  protected productType = ProductType;
  protected finishName: FinishHandle | null = null;
  protected showSummary = false;

  @Watch("finishName")
  private getFinishName(stringHandle: FinishHandle): FinishDisplayName {
    return getFinishName(stringHandle);
  }

  async created(): Promise<void> {
    if (this.$route.params.id) {
      this.showLoader();
      const editExisting = this.$route.query.edit as string;
      const id = this.$route.params.id;
      const status = this.$route.query.status;
      if (editExisting || status === OrderStatus.Open) {
        await this.getQuote(id as string, editExisting);
      } else {
        await this.getOrder(id as string, editExisting);
      }
    } else {
      this.triggerUpdate(undefined, { multiplier: this.multiplier });
      this.showSummary = true;
    }
  }

  // Main = Top
  protected hasEqualMainTopFabrics(canopy: any) {
    return canopy.mainFabric.length === 1 &&
      canopy.ventTopFabric.length === 1 &&
      canopy.mainFabric[0]._id === canopy.ventTopFabric[0]._id
      ? true
      : false;
  }

  // Main = Middle
  protected hasEqualMainMiddleFabrics(canopy: any) {
    const mainFabric = canopy.mainFabric;
    const ventMiddleFabric = canopy.ventMiddleFabric;
    let result = true;
    if (mainFabric.length === ventMiddleFabric.length) {
      for (const index in mainFabric) {
        if (mainFabric[index]._id === ventMiddleFabric[index]._id) {
          continue;
        } else {
          result = false;
          break;
        }
      }
    } else {
      result = false;
    }
    return result;
  }

  // Top = Middle
  protected hasEqualTopMiddleFabrics(canopy: any) {
    const ventTopFabric = canopy.ventTopFabric;
    const ventMiddleFabric = canopy.ventMiddleFabric;
    let result = true;
    if (ventTopFabric.length === ventMiddleFabric.length) {
      for (const index in ventTopFabric) {
        if (ventTopFabric[index]._id === ventMiddleFabric[index]._id) {
          continue;
        } else {
          result = false;
          break;
        }
      }
    } else {
      result = false;
    }
    return result;
  }

  protected editCartItem(index: number): void {
    this.editItem(index);
  }

  protected hasDesignerLayout(preset: option.Preset | null): boolean {
    switch (preset) {
      case option.Preset.D1:
      case option.Preset.D2:
      case option.Preset.D3:
        return true;
      default:
        return false;
    }
  }

  protected getDesignerLayoutName(preset: option.Preset): string {
    switch (preset) {
      case option.Preset.D1:
        return option.PresetDesignerNames.D1;
      case option.Preset.D2:
        return option.PresetDesignerNames.D2;
      case option.Preset.D3:
        return option.PresetDesignerNames.D3;
      default:
        return option.PresetDesignerNames.None;
    }
  }

  /**
   * editExisting === true -> edit
   * editExisting === false -> duplicate
   *
   */
  protected async getQuote(id: string, editExisting = ""): Promise<void> {
    this.id = id;
    let isEdit = false;
    if (editExisting && editExisting === "true") {
      isEdit = true;
    }
    try {
      const res: OrderRecord = await this.orderService.getSingleQuote(
        id,
        !editExisting ? true : false
      );
      res.created_type = !editExisting ? CreatedType.Duplicated : undefined;
      await this.resetOrder();
      await this.addOrder(res as any);
      if (res.customer_id && res.customer_id._id) {
        const customer = await this.customerService.getSingleCustomer(
          res.customer_id._id
        );
        await this.assignCustomer({
          customer_id: res.customer_id._id,
          customer_name: res.customer_id.customer_name,
          order_id: isEdit ? id : null, // will create a new order when saving if there is no id in the store. if isEdit is true, we are editing quote (vs duplicating)
        });
      } else {
        await this.assignCustomer({
          customer_id: "",
          customer_name: "",
          order_id: isEdit ? id : null, // will create a new order when saving if there is no id in the store. if isEdit is true, we are editing quote (vs duplicating)
        });
      }
      this.addMultiplier(this.getMultiplier(res.items as LineItem[]));
      await this.replaceLineItems(res.items as LineItem[]);
      this.triggerUpdate(undefined, { multiplier: this.multiplier });
      this.$nextTick(() => {
        this.closeLoader();
        this.showSummary = true;
      });
    } catch (err) {
      //this.$router.push("/not-found?error=order");
      this.$nextTick(() => this.closeLoader());
      GenericError.popup(err.message);
    }
  }

  protected async getOrder(id: string, editExisting = ""): Promise<void> {
    try {
      const res: OrderRecord = await this.orderService.getSingleOrder(
        id,
        !editExisting ? true : false
      );
      res.created_type = !editExisting ? CreatedType.Duplicated : undefined;
      await this.resetOrder();
      await this.addOrder(res as any);
      if (res.customer_id && res.customer_id._id) {
        const customer = await this.customerService.getSingleCustomer(
          res.customer_id._id
        );
        await this.assignCustomer({
          customer_id: res.customer_id._id,
          customer_name: res.customer_id.customer_name,
          order_id: null, // will create a new order when saving if there is no id in the store
        });
      } else {
        await this.assignCustomer({
          customer_id: "",
          customer_name: "",
          order_id: null, // will create a new order when saving if there is no id in the store
        });
      }
      this.addMultiplier(this.getMultiplier(res.items as LineItem[]));
      await this.replaceLineItems(res.items as LineItem[]);
      this.triggerUpdate(undefined, { multiplier: this.multiplier });
      this.$nextTick(() => {
        this.closeLoader();
        this.showSummary = true;
      });
    } catch (err) {
      //this.$router.push("/not-found?error=order");
      this.$nextTick(() => this.closeLoader());
      GenericError.popup(err.message);
    }
  }

  protected showLoader(): void {
    this.loader = this.$loading.show(
      {
        opacity: 1,
      },
      {
        before: this.$createElement("h1", {
          domProps: { innerHTML: "Loading quote..." },
        }),
      }
    );
  }

  protected closeLoader(): void {
    setTimeout(() => {
      this.loader.hide();
    }, 300);
  }

  protected deleteItem(): void {
    const itemsCopy = JSON.parse(JSON.stringify(this.items));
    itemsCopy.splice(this.upForDelete, 1);
    this.replaceLineItems(itemsCopy);
    this.close();
  }

  protected toggleModal(index: number) {
    this.showModal = true;
    this.upForDelete = index;
  }

  protected close(): void {
    this.upForDelete = null;
    this.showModal = false;
  }

  protected setQty(qty: number, index: number): void {
    this.triggerUpdate(index, { qty });
  }

  protected setMultiplier(multiplier: number, index: number): void {
    this.triggerUpdate(index, { multiplier });
  }

  protected triggerUpdate(
    index: number | undefined,
    options: { qty?: number; multiplier?: number }
  ): void {
    const itemsCopy: LineItem[] = JSON.parse(JSON.stringify(this.items));
    if (options.multiplier) {
      this.addMultiplier(options.multiplier);
      this.items.map((lineItem: LineItem, idx: number) => {
        const newItem = Object.assign({}, { ...this.items[idx] }, options);
        itemsCopy.splice(idx, 1, newItem);
        this.replaceLineItems(itemsCopy);
      });
    } else {
      if (typeof index === 'number') {
        const newItem = Object.assign({}, { ...this.items[index] }, options);
        itemsCopy.splice(index, 1, newItem);
        this.replaceLineItems(itemsCopy);
      }
    }
  }

  protected getMultiplier(items: LineItem[]): number {
    // 11/3/2023_FUPOF-137: Quotes are to have the same multiplier for all items.
    let multiplier = 1;
    if (items.length > 0 && items[0].multiplier) {
      multiplier = items[0].multiplier;
    }
    return multiplier;
  }

  protected async updateNotes(itemNotes: Note[], index: number) {
    const newDetails = Object.assign(
      {},
      { ...this.items[index].item_details! },
      { notes: itemNotes }
    );
    const newItem = JSON.parse(JSON.stringify(this.items[index]));
    newItem.item_details = newDetails;
    const itemsCopy = JSON.parse(JSON.stringify(this.items));
    itemsCopy.splice(index, 1, newItem);
    await this.replaceLineItems(itemsCopy);
  }
}
